'use client'
import { PrismicRichText } from "@prismicio/react";
import { isFilled } from "@prismicio/client";
import CtaSimple from "@/components/CtaSimple";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxVillesMarkers from "@/components/MapBoxVillesMarkers";

const HighlightedLocationsMap = ({ slice }) => {
  const { title, cta, description } = slice.primary;

  if (slice.variation === "fullMap") {
    return (
      <section
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className="bg-white framing overflow-hidden text-dark-green"
      >
        <div className="w-full my-14 lg:my-20 max-w-375 mx-auto ">
          <div className="flex-1 flex flex-col gap-14">
            <div className="flex flex-col gap-6">
              {isFilled.richText(title) && (
                <PrismicRichText
                  field={title}
                  components={{
                    heading2: ({ children }) => (
                      <h2 className="h3">
                        {children}
                      </h2>
                    ),
                    heading3: ({ children }) => (
                      <h3 className="h3">
                        {children}
                      </h3>
                    ),
                  }}
                />
              )}
              <div className="flex gap-10 max-w-175">
                {isFilled.richText(description) && (
                  <div className="flex-1 flex flex-col gap-5">
                    <PrismicRichText
                      field={description}
                      components={{
                        heading2: ({ children }) => (
                          <h2 className="h3">
                            {children}
                          </h2>
                        ),
                        heading3: ({ children }) => (
                          <h3 className="h3">
                            {children}
                          </h3>
                        ),
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="md:hidden">
              <MapboxVillesMarkers height={"65vh"}/>
            </div>
            <div className="hidden md:block">
              <MapboxVillesMarkers height={"80vh"} defaultZoom={5} />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white framing overflow-hidden text-dark-green"
    >
      <div className="w-full max-w-375 mx-auto my-14 lg:my-20 flex gap-25 items-center">

        <div className="w-119 hidden lg:block">
          <MapboxVillesMarkers />
        </div>

        <div className="flex-1 flex flex-col gap-14">
          <div className="flex flex-col gap-6">
            {isFilled.richText(title) && (
              <PrismicRichText
                field={title}
                components={{
                  heading2: ({ children }) => (
                    <h2 className="h3">
                      {children}
                    </h2>
                  ),
                  heading3: ({ children }) => (
                    <h3 className="h3">
                      {children}
                    </h3>
                  ),
                }}
              />
            )}
            <div className="w-full lg:hidden">
              <MapboxVillesMarkers />
            </div>
            <div className="flex gap-10">
              {isFilled.richText(description) && (
                <div className="flex-1 flex flex-col gap-5">
                  <PrismicRichText
                    field={description}
                    components={{
                      heading2: ({ children }) => (
                        <h2 className="h3">
                          {children}
                        </h2>
                      ),
                      heading3: ({ children }) => (
                        <h3 className="h3">
                          {children}
                        </h3>
                      ),
                    }}
                  />
                  {isFilled.link(cta) && (
                    <div className="hidden md:block lg:hidden mt-5">
                      <CtaSimple page={cta} padding={"px-5"} />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {isFilled.link(cta) && (
            <div className="flex md:hidden lg:flex">
              <CtaSimple page={cta} padding={"px-5"} width={"w-full md:w-auto"} hover={"dark-green"} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default HighlightedLocationsMap;
